import { useContext } from "react";
import { LoginContext } from "../Components/Contexts/LoginContext";

const useSecurity = () => {
  const { state } = useContext(LoginContext);
  const userPrivileges = state.userPrivileges;
  const userRole = state.userRole;
  const stateUsername = state.userName;

  const hasPrivilege = (privilege) => {
    if (typeof userPrivileges === "string") return userPrivileges.split(",").includes(privilege);
    else return userPrivileges.includes(privilege);
  };

  const isBackendUser = () => {
    return hasPrivilege("BackendUser");
  };

  const isCustomer = () => {
    return !isBackendUser();
  };

  const isDisableBillingInfo = () => {
    return userRole === "ACCOUNT_USER_NO_BILLING" || hasPrivilege("DisableBillingInfo");
  };

  const isUsernameEquals = (username) => {
    return stateUsername === username;
  };

  const isUsernameIn = (usernames) => {
    return usernames.includes(stateUsername);
  };

  const getUserId = () => {
    return state.userId;
  };

  const getUsername = () => {
    return state.userName;
  };

  const getAccountId = () => {
    return state.accountId;
  };

  const isUserRoleEquals = (role) => {
    return userRole === role;
  };

  const isUserRoleIn = (roles) => {
    return roles.includes(userRole);
  };

  return {
    hasPrivilege,
    isDisableBillingInfo,
    isUsernameEquals,
    isUsernameIn,
    getUserId,
    getUsername,
    getAccountId,
    isUserRoleEquals,
    isUserRoleIn,
    isBackendUser,
    isCustomer,
  };
};

export default useSecurity;
